var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"in--date-picker",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.currentDate}})}
var staticRenderFns = []

export { render, staticRenderFns }